import React, { useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { FaPen } from 'react-icons/fa6'
import _ from 'lodash'

import * as Constants from '../../helpers/constants'
import showToastNotification from '../widgets/toastify'
import { ApiHelper } from '../../helpers/apihelper'

const initialState = {
  listSizeLimit: '',
  reason: '',
  showModal: false,
  isApiCallInProgress: false,
  errors: {}
}

function UpdateDeepVerifyListSizeModal({ data, getUserInfo, client }) {
  const [state, setState] = useState(initialState)
  const id = useSelector(state => state.user.id)

  const handleShowModal = () => {
    setState(prevState => ({
      ...prevState,
      showModal: true
    }))
  }

  const handleCloseModal = () => {
    setState(initialState)
  }

  const handleSaveChanges = () => {
    const requestBody = {
      client_secret: Constants.CLIENT_SECRET,
      co_user_id: data.user_id,
      list_size_limit: state.listSizeLimit,
      reason: state.reason,
      crm_user_data: {
        user_id: id
      }
    }

    const body = _.pick(requestBody, ApiHelper(client, 'UPDATE_DEEP_VERIFY_LIST_SIZE').API_BODY)
    setState(prevState => ({
      ...prevState,
      isApiCallInProgress: true
    }))
    ApiHelper(client, 'UPDATE_DEEP_VERIFY_LIST_SIZE').API(client, body)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: 'Failed',
            isSuccess: false
          })
        } else if (response.status === Constants.CO_API.SUCCESS) {
          getUserInfo()
          handleCloseModal()
          showToastNotification({
            message: 'Deep Verify List Size Limit updated successfully',
            isSuccess: true
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setState(prevState => ({
          ...prevState,
          isApiCallInProgress: false
        }))
      })
  }

  return (
    <>
      <Button
        size="sm"
        variant='outline-primary'
        onClick={handleShowModal}
        className='sm-btns'
      >
        <FaPen />
      </Button>
      <Modal
        show={state.showModal}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title className='fs-6 fw-bold'>
            Update Deep Verify List Size Limit to {data?.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body-bg-color'>
          <Form>
            <div className='row'>
              <Form.Group
                className='d-flex'
              >
                <div className='col-md-3'>
                  <Form.Label className='w-100 py-2'>
                    Current Limit:
                  </Form.Label>
                </div>
                <div className='col-md-9'>
                  <Form.Control
                    type="number"
                    value={data?.limits?.allowed_deep_verify_list_size || '-'}
                    disabled
                  />
                </div>
              </Form.Group>
            </div>
            <div className='row'>
              <Form.Group
                className='d-flex'
              >
                <div className='col-md-3'>
                  <Form.Label className='w-100 py-2'>
                    New List Size Limit:
                  </Form.Label>
                </div>
                <div className='col-md-9'>
                  <Form.Control
                    type="number"
                    placeholder="Enter List Size Limit"
                    value={state.listSizeLimit}
                    onChange={(e) => setState(prevState => ({
                      ...prevState,
                      listSizeLimit: e.target.value
                    }))}
                  />
                </div>
              </Form.Group>
            </div>
            <div className='row'>
              <Form.Group
                className='d-flex'
              >
                <div className='col-md-3'>
                  <Form.Label className='w-100 py-2'>
                    Reason:
                  </Form.Label>
                </div>
                <div className='col-md-9'>
                  <Form.Control
                    type="text"
                    placeholder="Enter Reason"
                    value={state.reason}
                    onChange={(e) => setState(prevState => ({
                      ...prevState,
                      reason: e.target.value
                    }))}
                  />
                </div>
              </Form.Group>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={handleSaveChanges}
            disabled={
              !state.listSizeLimit ||
              !state.reason ||
              state.isApiCallInProgress
            }
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default UpdateDeepVerifyListSizeModal